<template>
  <div>
    <div class="language-dropdown" :class="{ 'columns': enableColumns }" v-show="Object.keys(storeViews).length > 0">
      <div class="country country-current">
        <span class="mr10 country-code">{{ $t(fullCountryName) }}</span>
        <span class="down-arrow">
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z" fill="black" />
          </svg>
        </span>
      </div>
      <div class="country country-available" >
        <ul>
          <li>
            <a :href="getBaseUrl">{{ $t('PL') }}</a>
          </li>
          <li v-for="(storeView, storeCode) in storeViews" :key="storeCode" v-if="available[storeCode]">
            <a :href="getUrl(storeView.url)">{{ $t(storeView.i18n.defaultLanguage) }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from 'theme/components/core/Modal.vue'
import i18n from '@vue-storefront/i18n'
import config from 'config'
export default {
  components: {
    Modal
  },
  data () {
    return {
      minCountryPerColumn: 3,
      componentLoaded: false,
      available: {
        'pl': true,
        'en': true,
        'de': true
      }
    }
  },
  computed: {
    currentLocale () {
      return i18n.locale
    },
    fullCountryName () {
      if (i18n.locale === 'pl-PL') {
        return config.i18n.defaultLanguage
      } else if (i18n.locale === 'en-US') {
        return config.storeViews['en'].i18n.defaultLanguage
      } else {
        return config.storeViews['de'].i18n.defaultLanguage
      }
    },
    fullLanguageName () {
      return config.i18n.fullLanguageName
    },
    enableColumns () {
      const enableStoreViews = Object.keys(this.storeViews)
      return enableStoreViews.length > this.minCountryPerColumn
    },
    storeViews () {
      return Object.keys(config.storeViews).reduce((storeViews, storeCode) => {
        if (this.isValidStoreCode(storeCode) && this.available[storeCode]) {
          storeViews[storeCode] = config.storeViews[storeCode]
        }
        return storeViews
      }, {})
    },
    getBaseUrl () {
      return config.baseUrl ? config.baseUrl : '/'
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.componentLoaded = true
      // this.$bus.$emit('modal-show', 'modal-switcher')
    })

    this.fetchCmsBlock();
  },
  methods: {
    close () {
      // this.$bus.$emit('modal-hide', 'modal-switcher')
    },
    isValidStoreCode (storeCode) {
      const storeView = config.storeViews[storeCode]
      return !!(storeView && typeof storeView === 'object' && storeView.i18n)
    },
    getUrl (route) {
      const baseUrl = config.baseUrl ? config.baseUrl : ''
      return baseUrl + route.slice(1)
    },
    async fetchCmsBlock () {
      let queryKey = 'identifier'
      const block = await this.$store.dispatch('cmsBlock/single', {
        key: queryKey,
        value: 'l_blackpointB2C'
      })
      
      if (block) {
        this.available['pl'] = true;
      } else {
        this.available['pl'] = false;
      }

      const blockEn = await this.$store.dispatch('cmsBlock/single', {
        key: queryKey,
        value: 'l_blackpointB2C_EN'
      })
      if (blockEn) {
        this.available['en'] = true;
      } else {
        this.available['en'] = false;
      }
      const blockDe = await this.$store.dispatch('cmsBlock/single', {
        key: queryKey,
        value: 'l_blackpointB2C_DE'
      })
      if (blockDe) {
        this.available['de'] = true;
      } else {
        this.available['de'] = false;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .language-dropdown {
    position: relative;
    width: 70px;
    height: 40px;
    display: inline-block;
    border-radius: 22px;
    border: 1px solid black;

    .country-available {
      display: none;
      position: absolute;
      z-index: 2;
      right: 0;
      left: 0;
      background: white;
      line-height: 28px;
      text-align: left;
      top: 43px;
      border-radius: 2px;
      box-shadow: 0 0px 1px 1px #7d7d7d1a;
      
      li {
        line-height: 28px;
        padding: 4px 0 4px 16px;
      }
    }

    .country-current {
      margin-bottom: 0;
      line-height: 40px;
      text-align: center;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;

      .down-arrow svg {
        width: 18px;
        height: 12px;
        stroke: black;
        transform: rotate(180deg);
        margin-right: -10px;
        margin-bottom: -4px;
      }
    }

    &:hover {
      .country-available {
        display: inline-block;
      }

      .country-current {
        .country-code {
          margin-left: -8px;
          margin-right: 12px;
        }

        .down-arrow svg {
          transform: rotate(0deg);
          margin-left: -8px;
          margin-bottom: 2px;
        }
      }
    }
  }

  h3 {
    margin-top: 0;
    margin-bottom: 0.5em;
  }
  .columns {
    -moz-column-count: 2;
    column-count: 2;
    column-gap: 15px;
    .country {
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
    }
  }
  .country {
    color: #000;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    margin-left: -1em;
    li {
      margin-left: 1em;
      a {
        font-size: 0.9em;
        color: #000;
      }
    }
  }
</style>
